package dev.shaughnessy.knittingcolorpicker.knittingcolorpicker

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.luminance
import kotlinx.browser.document
import org.w3c.dom.HTMLAnchorElement
import org.w3c.dom.HTMLCanvasElement
import org.w3c.dom.CanvasRenderingContext2D
import org.w3c.dom.CanvasTextAlign
import org.w3c.dom.CanvasTextBaseline
import org.w3c.dom.CENTER
import org.w3c.dom.MIDDLE

actual fun downloadScreenshot(colors: List<Color>, assignedNumbers: Map<Int, Int>, assignedRowHeights: Map<Int, Int>, count: Int) {
    val canvas = document.createElement("canvas") as HTMLCanvasElement
    val ctx = canvas.getContext("2d") as CanvasRenderingContext2D
    
    val boxSize = 60.0
    val padding = 10.0
    val textHeight = 20.0
    val totalWidth = (boxSize + padding) * count + padding
    val totalHeight = boxSize + textHeight + 2 * padding
    
    canvas.width = totalWidth.toInt()
    canvas.height = totalHeight.toInt()
    
    // Fill background
    ctx.fillStyle = "#FFFFFF"
    ctx.fillRect(0.0, 0.0, totalWidth, totalHeight)
    
    ctx.font = "20px sans-serif"
    ctx.textAlign = CanvasTextAlign.CENTER
    ctx.textBaseline = CanvasTextBaseline.MIDDLE
    
    // Create a sorted list of indices based on assigned numbers
    val sortedIndices = (0 until count).sortedBy { index ->
        assignedNumbers[index] ?: (Int.MAX_VALUE - count + index)
    }
    
    for (i in 0 until count) {
        val originalIndex = sortedIndices[i]
        val x = padding + i * (boxSize + padding)
        val y = padding
        
        val color = colors[originalIndex]
        // Convert Color to hex string
        val r = (color.red * 255).toInt()
        val g = (color.green * 255).toInt()
        val b = (color.blue * 255).toInt()
        val hex = "#" + 
            r.toString(16).padStart(2, '0') + 
            g.toString(16).padStart(2, '0') + 
            b.toString(16).padStart(2, '0')
        
        ctx.fillStyle = hex
        ctx.fillRect(x, y, boxSize, boxSize)
        
        val number = assignedNumbers[originalIndex]
        if (number != null) {
            ctx.fillStyle = if (color.luminance() > 0.5f) "#000000" else "#FFFFFF"
            ctx.fillText(number.toString(), x + boxSize / 2, y + boxSize / 2)
        }
        
        val rowHeight = assignedRowHeights[originalIndex]
        if (rowHeight != null) {
            ctx.fillStyle = "#000000"
            ctx.font = "12px sans-serif"
            ctx.fillText("Rows: $rowHeight", x + boxSize / 2, y + boxSize + 10)
            ctx.font = "20px sans-serif" // Reset font
        }
    }
    
    val dataUrl = canvas.toDataURL("image/png")
    val a = document.createElement("a") as HTMLAnchorElement
    a.href = dataUrl
    a.download = "knitting_colors.png"
    document.body?.appendChild(a)
    a.click()
    document.body?.removeChild(a)
}